(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upgrade-kit-selector"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-ukf]');
  roots.forEach((root) => {
    if (root.dataset.ukfReady === 'true') return;
    root.dataset.ukfReady = 'true';

    const data = JSON.parse(root.querySelector('[data-product-data]').textContent);
    const kits = data.kits;
    const helpImages = data.helpImages || {};
    const home = root.querySelector('[data-home]');
    const app = root.querySelector('[data-app]');
    const screen = root.querySelector('[data-screen]');
    const close = root.querySelector('[data-close]');
    const progress = root.querySelector('[data-progress]');
    const progressLabel = root.querySelector('[data-progress-label]');
    const progressBar = root.querySelector('[data-progress-bar]');
    const helpModal = root.querySelector('[data-help-modal]');
    const helpModalImage = root.querySelector('[data-help-modal-image]');
    const helpModalTitle = root.querySelector('[data-help-title]');

    let mode = null;
    let step = 0;
    let answers = {};
    let compatible = kits.slice();

    const finderQuestions = [
      {id:'purpose', title:'What will you mainly use your upgraded e-bike for?', type:'radio', options:[['commute','Commuting'],['offroad','Off-road riding'],['cargo','Cargo / utility'],['recreation','Recreation']]},
      {id:'terrain', title:'Where do you ride most often?', type:'radio', options:[['pavement','Pavement'],['mixed','Mixed surfaces'],['trail','Trail'],['mountain','Mountain / steep terrain'],['sand','Sand'],['snow','Snow']]},
      {id:'speed', title:'What top speed are you looking for?', type:'select', options:[[20,'20 mph'],[25,'25 mph'],[30,'30 mph'],[35,'35 mph'],[40,'40 mph'],[45,'45+ mph']]},
      {id:'distance', title:'How far do you usually want to ride on one trip?', type:'number', min:1, max:150, unit:'miles'},
      {id:'weight', title:'What is the rider weight?', type:'number', min:70, max:400, unit:'lbs'},
      {id:'budget', title:'What is your upgrade kit budget?', type:'select', options:[[300,'Under $300'],[500,'$300–$500'],[1000,'$500–$1,000'],[1500,'$1,000–$1,500'],[3000,'$1,500+']]},
      {id:'priorities', title:'What matters most to you?', type:'checkbox', options:[['power','Power'],['speed','Speed'],['offroad','Off-road performance'],['budget','Budget'],['versatility','Versatility']]},
    ];

    const compatibilityQuestions = [
      {id:'motorPosition', title:'Is your motor a rear hub motor?', type:'radio', helpText:'How to Check Motor Position', options:[['rear','Yes — Rear hub motor'],['not-rear','No — Another motor position']]},
      {id:'dropout', title:'What is your rear dropout width?', type:'radio', helpText:'How to Measure OLD', options:[[170,'170 mm'],[175,'175 mm'],[190,'190 mm'],['other','None of these']]},
      {id:'brake', title:'What brake type does your e-bike use?', type:'radio', helpText:'How to Check Brake Type', options:[['disc','Disc Brake'],['v','V-Brake'],['other','Neither of these']]},
      {id:'wheel', title:'What is your wheel size?', type:'radio', helpText:'How to Measure Wheel Size', options:[['20-24','20–24 inch'],['24-28','24–28 inch'],['other','Outside 20–28 inch']]},
      {id:'handlebar', title:'What is your handlebar diameter?', type:'radio', helpText:'How to Measure Handlebar Diameter', options:[[22.2,'22.2 mm'],[25.4,'25.4 mm'],[31.8,'31.8 mm'],['other','None of these']]},
    ];

    const combinedQuestions = compatibilityQuestions.concat(finderQuestions);

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (m) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
    }

    function renderQuestion(q) {
      let body = '';
      const helpImage = helpImages[q.id];
      const help = q.helpText && helpImage ? `<div class="ukf-help"><button class="ukf-help__trigger" type="button" data-help-image="${escapeHtml(helpImage)}" data-help-label="${escapeHtml(q.helpText)}" aria-haspopup="dialog">${escapeHtml(q.helpText)}<span class="ukf-help__preview" aria-hidden="true"><img src="${escapeHtml(helpImage)}" alt="" width="480" height="360" loading="lazy"></span></button></div>` : '';
      if (q.type === 'radio' || q.type === 'checkbox') {
        body = `<div class="ukf-options">${q.options.map((o) => `
          <label class="ukf-option"><input type="${q.type}" name="${q.id}" value="${escapeHtml(o[0])}" ${q.type === 'radio' ? 'required' : ''} ${(q.type === 'checkbox' ? (answers[q.id] || []).includes(String(o[0])) : String(answers[q.id]) === String(o[0])) ? 'checked' : ''}> ${escapeHtml(o[1])}</label>
        `).join('')}</div>`;
      } else if (q.type === 'select') {
        body = `<select class="ukf-select" name="${q.id}" required><option value="">Select an option</option>${q.options.map(o => `<option value="${o[0]}" ${String(answers[q.id]) === String(o[0]) ? 'selected' : ''}>${escapeHtml(o[1])}</option>`).join('')}</select>`;
      } else {
        body = `<input class="ukf-number" type="number" name="${q.id}" min="${q.min}" max="${q.max}" value="${escapeHtml(answers[q.id] || '')}" required><div class="ukf-note">Enter ${q.min}–${q.max} ${q.unit}.</div>`;
      }
      return `<div class="ukf-screen"><h2>${escapeHtml(q.title)}</h2><p class="ukf-screen__sub">${mode === 'compatibility' || mode === 'compatibility-finder' ? 'We will use your e-bike specifications to check compatibility.' : 'We will use this information to compare the Upgrade Kits.'}</p><form class="ukf-form" data-question-form novalidate><fieldset class="ukf-field"><legend>${escapeHtml(q.title)}</legend>${body}${help}</fieldset><div class="ukf-actions"><button class="ukf-btn ukf-btn--secondary" type="button" data-step-back ${step === 0 ? 'disabled' : ''}>Back</button><button class="ukf-btn" type="submit">${step === currentQuestions().length - 1 ? 'See Results' : 'Continue'}</button></div></form></div>`;
    }

    function currentQuestions() {
      if (mode === 'finder') return finderQuestions;
      if (mode === 'compatibility') return compatibilityQuestions;
      return combinedQuestions;
    }

    function readForm(form) {
      const formData = new FormData(form);
      const q = currentQuestions()[step];
      if (q.type === 'checkbox') {
        answers[q.id] = formData.getAll(q.id);
      } else {
        answers[q.id] = formData.get(q.id);
      }
    }

    function validateQuestion(form, q) {
      const controls = Array.from(form.elements).filter(control => control.name === q.id);
      const first = controls[0];
      if (!first) return false;
      controls.forEach(control => control.setCustomValidity(''));

      if (q.type === 'radio' && !controls.some(control => control.checked)) {
        first.setCustomValidity('Please select an option from the list.');
        first.reportValidity();
        return false;
      }
      if (q.type === 'checkbox' && !controls.some(control => control.checked)) {
        first.setCustomValidity('Please select at least one option.');
        first.reportValidity();
        return false;
      }
      if (q.type === 'select' && !first.value) {
        first.setCustomValidity('Please select an option from the list.');
        first.reportValidity();
        return false;
      }
      if (q.type === 'number') {
        const value = Number(first.value);
        if (!first.value) {
          first.setCustomValidity(`Please enter a value between ${q.min} and ${q.max} ${q.unit}.`);
          first.reportValidity();
          return false;
        }
        if (!Number.isFinite(value) || value < q.min || value > q.max) {
          first.setCustomValidity(`Please enter a value between ${q.min} and ${q.max} ${q.unit}.`);
          first.reportValidity();
          return false;
        }
      }
      return true;
    }

    function filterCompatible(list, questionId, value) {
      return list.filter(k => {
        if (questionId === 'motorPosition') return value === k.motorPosition;
        if (questionId === 'dropout') return value !== 'other' && k.dropouts.includes(Number(value));
        if (questionId === 'brake') return value !== 'other' && k.brakes.includes(value);
        if (questionId === 'wheel') {
          if (value === '20-24') return k.wheelMin <= 20 && k.wheelMax >= 24;
          if (value === '24-28') return k.wheelMin <= 24 && k.wheelMax >= 28;
          return false;
        }
        if (questionId === 'handlebar') return value !== 'other' && k.handlebars.includes(Number(value));
        return true;
      });
    }

    function compatibilityCheck(questionCount = compatibilityQuestions.length) {
      let list = kits.slice();
      compatibilityQuestions.slice(0, questionCount).forEach(q => {
        if (answers[q.id] !== undefined && answers[q.id] !== null) {
          list = filterCompatible(list, q.id, answers[q.id]);
        }
      });
      return list;
    }

    function speedScore(power, speed) {
      const s = Number(speed);
      const target = power === 750 ? 25 : power === 1000 ? 32 : 40;
      const gap = Math.abs(s - target);
      return Math.max(0, 100 - gap * 7);
    }

    function scoreKit(k) {
      const priority = answers.priorities || [];
      const weights = {
        power: priority.includes('power') ? 30 : 15,
        speed: priority.includes('speed') ? 25 : 12,
        offroad: priority.includes('offroad') ? 20 : 10,
        budget: priority.includes('budget') ? 15 : 5,
        versatility: priority.includes('versatility') ? 10 : 5
      };
      let score = 0;
      let total = Object.values(weights).reduce((a,b) => a+b, 0);

      const desiredSpeed = Number(answers.speed);
      const speedFit = speedScore(k.power, desiredSpeed);
      score += speedFit * weights.speed / 100;

      const weight = Number(answers.weight);
      const powerFit = weight <= 180 ? (k.power >= 750 ? 100 : 80) :
        weight <= 220 ? (k.power >= 1000 ? 100 : 70) :
        weight <= 280 ? (k.power >= 1500 ? 100 : k.power >= 1000 ? 75 : 45) :
        (k.power >= 1500 ? 100 : 50);
      score += powerFit * weights.power / 100;

      const terrain = answers.terrain;
      const offroadFit = terrain === 'pavement' ? (k.power === 750 ? 100 : 80) :
        terrain === 'mixed' ? 95 :
        (k.power >= 1000 ? 100 : 70);
      score += offroadFit * weights.offroad / 100;

      const budget = Number(answers.budget);
      const budgetFit = k.priceFrom <= budget ? 100 : Math.max(0, 100 - (k.priceFrom - budget) / Math.max(1,budget) * 100);
      score += budgetFit * weights.budget / 100;

      const versatilityFit = k.id === 'bk750' ? 100 : 85;
      score += versatilityFit * weights.versatility / 100;

      const distance = Number(answers.distance);
      const distanceFit = distance <= 20 ? (k.power <= 1000 ? 100 : 90) :
        distance <= 40 ? 95 :
        (k.power <= 1000 ? 100 : 85);
      score += distanceFit * 0.08;

      total += 8;
      return Math.round(Math.min(100, score / total * 100));
    }

    function renderCompatibilityResults(list) {
      progress.hidden = true;
      const title = list.length ? 'Compatible Upgrade Kits' : 'No Compatible Upgrade Kit Found';
      screen.innerHTML = `<div class="ukf-screen ukf-results"><h2>${title}</h2><p class="ukf-screen__sub">${list.length ? 'Based on your answers, these Upgrade Kits are compatible with your e-bike:' : 'One or more of your selections is not compatible with any available Upgrade Kit.'}</p>${list.length ? `<div class="ukf-compatible">${list.map(k => `<div class="ukf-compatible__item"><strong>${escapeHtml(k.name)}</strong><span>From $${k.priceFrom.toFixed(2)}</span>${k.url ? `<a class="ukf-link" href="${escapeHtml(k.url)}">View Upgrade Kit →</a>` : ''}</div>`).join('')}</div>` : `<div class="ukf-empty">Please review the motor position, rear dropout width, brake type, wheel size, and handlebar diameter.</div>`}<div class="ukf-actions"><button class="ukf-btn ukf-btn--secondary" type="button" data-review-answers>Review answers</button></div><p class="ukf-note">Compatibility is based on the product specifications currently configured in this tool. Always confirm physical fitment before installation.</p></div>`;
      screen.querySelector('[data-review-answers]').addEventListener('click', () => {
        step = Math.max(0, Math.min(step, compatibilityQuestions.length - 1));
        renderStep();
      });
    }

    function renderRecommendationResults(list) {
      const scored = list.map(k => ({...k, score: scoreKit(k)})).sort((a,b) => b.score - a.score);
      progress.hidden = true;
      screen.innerHTML = `<div class="ukf-screen ukf-results"><h2>${mode === 'compatibility-finder' ? 'Your Compatible Upgrade Kit Recommendation' : 'Your Upgrade Kit Recommendation'}</h2><p class="ukf-screen__sub">${mode === 'compatibility-finder' ? 'Only Upgrade Kits compatible with your e-bike were scored.' : 'The results below are ranked by how closely they match your riding needs.'}</p>${scored.length ? `<div class="ukf-result-list">${scored.map((k,i) => `<article class="ukf-result ${i === 0 ? 'ukf-result--top' : ''}"><div><h3>${escapeHtml(k.name)}${i === 0 ? ' — Recommended' : ''}</h3><p>Rated power: ${k.power} W · From $${k.priceFrom.toFixed(2)}</p>${k.url ? `<a class="ukf-link" href="${escapeHtml(k.url)}">View Upgrade Kit →</a>` : ''}</div><div class="ukf-score">${k.score}%<div class="ukf-price">match</div></div></article>`).join('')}</div>` : `<div class="ukf-empty">No compatible Upgrade Kits were found, so a recommendation cannot be made.</div>`}</div>`;
    }

    function renderStep() {
      const qs = currentQuestions();
      const q = qs[step];
      progress.hidden = false;
      progressLabel.textContent = `Question ${step + 1} of ${qs.length}`;
      progressBar.style.width = `${((step + 1) / qs.length) * 100}%`;
      screen.innerHTML = renderQuestion(q);
      const form = screen.querySelector('[data-question-form]');
      const helpTrigger = form.querySelector('[data-help-image]');
      if (helpTrigger) {
        helpTrigger.addEventListener('click', () => {
          helpModalImage.src = helpTrigger.dataset.helpImage;
          helpModalImage.alt = helpTrigger.dataset.helpLabel;
          helpModalTitle.textContent = helpTrigger.dataset.helpLabel;
          helpModal.showModal();
        });
      }
      form.querySelector('[data-step-back]').addEventListener('click', () => {
        if (step === 0) return;
        step -= 1;
        renderStep();
      });
      Array.from(form.elements).forEach(control => {
        control.addEventListener('input', () => control.setCustomValidity(''));
        control.addEventListener('change', () => control.setCustomValidity(''));
      });
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (!validateQuestion(form, q)) return;
        readForm(form);
        const compatibilityIndex = compatibilityQuestions.findIndex(item => item.id === q.id);
        if (mode !== 'finder' && compatibilityIndex !== -1) {
          compatible = compatibilityCheck(compatibilityIndex + 1);
          if (!compatible.length) {
            renderCompatibilityResults([]);
            return;
          }
        }
        if (step < qs.length - 1) {
          step += 1;
          renderStep();
          return;
        }
        if (mode === 'compatibility') {
          compatible = compatibilityCheck();
          renderCompatibilityResults(compatible);
        } else if (mode === 'compatibility-finder') {
          compatible = compatibilityCheck();
          renderRecommendationResults(compatible);
        } else {
          renderRecommendationResults(kits);
        }
      });
    }

    function start(selectedMode) {
      mode = selectedMode;
      step = 0;
      answers = {};
      compatible = kits.slice();
      home.hidden = true;
      app.hidden = false;
      renderStep();
    }

    root.querySelectorAll('[data-mode]').forEach(btn => btn.addEventListener('click', () => start(btn.dataset.mode)));
    root.querySelector('[data-help-close]').addEventListener('click', () => helpModal.close());
    helpModal.addEventListener('click', (event) => {
      if (event.target === helpModal) helpModal.close();
    });
    close.addEventListener('click', () => {
      app.hidden = true;
      home.hidden = false;
      progress.hidden = true;
      screen.innerHTML = '';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
